module.exports = __webpack_public_path__ + "static/img/data.cba30672.svg";